import { AudacyColors, BasicColors, GreyScale } from '@audacy-clients/core/styles/colors';

import { BP, Mixins, Outlines, mq, mqHover } from '~/styles';
import type { TStyleSheet } from '~/types/emotion-styles';

const styles: TStyleSheet = {
  container: {
    height: '100vh',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '100vw',
  },
  inner: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  modal: {
    backgroundColor: BasicColors.white,
    borderRadius: 4,
    position: 'relative',
    width: '100%',
    [mq(BP.Large)]: {
      width: 572,
    },
  },
  modalContent: {
    height: '100%',
    maxHeight: 400,
    overflow: 'auto',
    padding: 60,
    width: '100%',
  },
  closeButton: {
    position: 'absolute',
    right: 22,
    top: 22,
    ...Mixins.focusOutline({
      outlineOffset: 0,
      outline: `${Outlines.focusDark}`,
    }),
    color: AudacyColors.audacyDarkNavy,
    ...mqHover({
      color: GreyScale.greyC5,
    }),
  },
};

export default styles;
